/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContainerTypesQuery } from '../../models/get-container-types-query';
import { GetContainerTypesQueryResult } from '../../models/get-container-types-query-result';

export interface ApiContainersGetContainerTypesPost$Params {
      body?: GetContainerTypesQuery
}

export function apiContainersGetContainerTypesPost(http: HttpClient, rootUrl: string, params?: ApiContainersGetContainerTypesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerTypesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersGetContainerTypesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContainerTypesQueryResult>;
    })
  );
}

apiContainersGetContainerTypesPost.PATH = '/api/Containers/GetContainerTypes';
